import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { createStyles, DialogActions } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import makeClass from 'classnames';
var useStyles = makeStyles(function () {
  return createStyles({
    root: {
      width: '100%',
      '& button:first-child': {
        marginRight: 'auto'
      }
    }
  });
});

var ModalActions = function ModalActions(_ref) {
  var children = _ref.children,
      getBodySlot = _ref.getBodySlot,
      splitActions = _ref.splitActions;
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(DialogActions, {
    className: makeClass(_defineProperty({}, classes.root, splitActions)),
    ref: bodyCb
  }, children);
};

export default ModalActions;

try {
  ModalActions.__docgenInfo = {
    description: '',
    displayName: 'ModalActions',
    methods: [],
    props: {
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      splitActions: {
        defaultValue: null,
        description: '',
        name: 'splitActions',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map